import { render, staticRenderFns } from "./FirmaNastaveni1.vue?vue&type=template&id=74a8581b&"
import script from "./FirmaNastaveni1.vue?vue&type=script&lang=ts&"
export * from "./FirmaNastaveni1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports